import * as React from 'react';
import { useState } from 'react'
import { msgTypes } from 'constants/msgTypes';
import { PaginatorModel } from 'model/utilModels/PaginatorModel';
import { MemberBankDetailsModel } from 'model/screensModels/MemberBankDetailsModel';
import { MemberBankDetailsService } from 'services/menu/memberBankDetailsService/MemberBankDetailsService';
import { Box } from '@mui/material';
import MemberBankDetailsList from './MemberBankDetailsList';
import CreateMemberBank from './CreateMemberBank';
import { RequestModel } from 'model/utilModels/RequestModel';
import { FinancialProtection } from '../financialProtection/FinancialProtection';
import { DataNotFound } from 'screens/sharedScreens/dataNotFound/DataNotFound';


export default function MemberBankDetails() {
  const [updateValue, setUpdateValue] = React.useState(new MemberBankDetailsModel());
  const [flag, setFlag] = useState(false)
  const [recentBankdetails, setRecentBankdetails] = useState(new MemberBankDetailsModel());
  const [isEditMode, setIsEditMode] = useState(false);
  

  React.useEffect(()=>{
    loadRecentBankDetails();
  },[])

  //Prepare request body
  const prepareRequest = () => {
    const requestBody = new RequestModel();
    requestBody.pageNumber = 0;
    requestBody.pageSize = 1;
    requestBody.companyId = "";
    return requestBody;
  }

  //Get recently added record
  const loadRecentBankDetails = async () => {
    const requestBody = prepareRequest();
    const res = await MemberBankDetailsService.getBankDetails(requestBody);
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      if (res?.data !== '') {
        setRecentBankdetails(res?.data?.tbody[0]);
      }else{
        setRecentBankdetails(new MemberBankDetailsModel())
      }
    }
  }


  //to get update record value
  const getUpdateRecordValue = (blogModel: MemberBankDetailsModel) => {
    setIsEditMode(true);
    setUpdateValue(blogModel);
  }

  const addBankDetails = () => {
    setUpdateValue(new MemberBankDetailsModel())
    setIsEditMode(false); // Reset edit mode
    setFlag(true);
  }


  const RecentBankDetails = () => {
    return (
      <>
        <h5 className='pb-3 recent-heading'>Recently added Bank Details </h5>
        {recentBankdetails.bankId!=='' ? (
        <div>
          <div className='row recent-row'>
            <div className='col-lg-4 '>
              <h5>Company : </h5>
            </div>
            <div className='col-lg-8'>
              {recentBankdetails.companyName}
            </div>
          </div>

          <div className='row recent-row'>
            <div className='col-lg-4 '>
              <h5>Account Holder Name : </h5>
            </div>
            <div className='col-lg-8'>
              {recentBankdetails.accountHolderName}
            </div>
          </div>

          <div className='row recent-row'>
            <div className='col-lg-4 '>
              <h5>Account Number : </h5>
            </div>
            <div className='col-lg-8'>
              {recentBankdetails.accountNumber}
            </div>
          </div>

          <div className='row recent-row'>
            <div className='col-lg-4 '>
              <h5>Bank Name: </h5>
            </div>
            <div className='col-lg-8'>
              {recentBankdetails.bankName}
            </div>
          </div>

          <div className='row recent-row'>
            <div className='col-lg-4 '>
              <h5>Country : </h5>
            </div>
            <div className='col-lg-8'>
              {recentBankdetails.countryName}
            </div>
          </div>

          <div className='row recent-row'>
            <div className='col-lg-4 '>
              <h5>Currency : </h5>
            </div>
            <div className='col-lg-8'>
              {recentBankdetails.currency}
            </div>
          </div>

          <div className='row recent-row'>
            <div className='col-lg-4 '>
              <h5>Branch Name : </h5>
            </div>
            <div className='col-lg-8'>
              {recentBankdetails.branchName}
            </div>
          </div>

          <div className='row recent-row'>
            <div className='col-lg-4 '>
              <h5>SWIFT/BIC Code : </h5>
            </div>
            <div className='col-lg-8'>
              {recentBankdetails.swiftCode}
            </div>
          </div>


          <div className='row recent-row'>
            <div className='col-lg-4 '>
              <h5>IBAN Code : </h5>
            </div>
            <div className='col-lg-8'>
              {recentBankdetails.iban}
            </div>
          </div>

          <div className='row recent-row'>
            <div className='col-lg-4 '>
              <h5>Routing No/ ABA No : </h5>
            </div>
            <div className='col-lg-8'>
              {recentBankdetails.routingNo}
            </div>
          </div>


          <div className='row recent-row'>
            <div className='col-lg-4 '>
              <h5>Type : </h5>
            </div>
            <div className='col-lg-8'>
              {recentBankdetails.type}
            </div>
          </div>


        </div>
      ) :(
          <>
          <DataNotFound message="There is no bank details"/>
          </>
         )}
      </>
    )
  }

  return (
    <>
      <Box sx={{ width: '100%' }} className="container container-h-full">
        <Box>
        
          <div className="content-subheader">
            {!flag ? (
              <h2 className="mr-3 font-weight-bolder">Bank List</h2>
            ) : (
              <h2 className="mr-3">{isEditMode ? 'Edit Bank Details' : 'Add Bank Details'}</h2>
            )}
            {!flag && <button className="btn primary" onClick={addBankDetails}>Add Bank Details</button>}
          </div>
        </Box>
       
          {!flag ?
            (<div className='sub-content-sec recently-blog'>
              <MemberBankDetailsList setFlag={setFlag} updateRecord={getUpdateRecordValue} loadRecentBankDetails={loadRecentBankDetails}></MemberBankDetailsList>
            </div>)
            :
            <>
                <div className='row'>
                  <div className='col-lg-5 work'>
                    <div className='sub-content-sec recently-blog'>
                      <RecentBankDetails />
                    </div>
                  </div>
                  <div className='col-lg-7'>
                    <div className='sub-content-sec recently-blog'>
                      <CreateMemberBank setFlag={setFlag} updateRecord={updateValue} loadRecentBankDetails={loadRecentBankDetails}></CreateMemberBank>
                    </div>
                  </div>
                </div>
            </>

          }
      </Box>
    </>
  );
}